(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = 'facebook';

    if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.fbq) return;


    // Facebook Globals

    window.fbq = window.fbq || function() {
        return (window.fbq.callMethod) ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = window.fbq;
    window.fbq.push = window.fbq;
    window.fbq.loaded = !0;
    window.fbq.version = '2.0';
    window.fbq.queue = [];


    function get_product_obj(data) {

        var product = {
            content_ids: [data.item.sku],
            content_type: 'product',
            content_name: data.item.sku + ": " + data.item.name
        };

        return product;
    }


    mL_events.subscribe('page', function(msg, data) {

        var fb_item = (msg === 'page.item') ? get_product_obj(data) : false;

        if (fb_item) {
            fbq('track', 'ViewContent', fb_item);
            if (mL_config.DEBUG) console.log(key + ' - ' + msg, { fb_item: fb_item });
        } else {
            if (mL_config.DEBUG) console.log(key + ' - ' + msg);
        }

        fbq('track', 'PageView');

    });

    mL_events.subscribe('cart.add_item', function(msg, data) {

        var fb_item = get_product_obj(data);

        fbq('track', 'AddToCart', fb_item);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, { fb_item: fb_item });
    });

    mL_events.subscribe('form.submit', function(msg, obj) {
        if (!obj.data || obj.data.form) return;

        var form_obj = { content_name: obj.data.form };

        if (!form_obj.content_name) return;

        fbq('track', 'Lead', form_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, { form_obj: form_obj });
    });

    mL_events.subscribe('order.pageview', function(msg, data) {
        var _url = data.url;

        if (_url.indexOf('confirmation') === -1) return;

        if (_url.indexOf('login-register') !== -1) {
            fbq('track', 'CompleteRegistration');
        } else if (_url.indexOf('opc') !== -1) {
            fbq('track', 'InitiateCheckout');
        } else if (_url.indexOf('review') !== -1) {
            fbq('track', 'AddPaymentInfo');
        }

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, _url);

    });

    mL_events.subscribe('order.confirmation', function(msg, data) {
        var _order = data.order;

        var fb_obj = {
            content_type: 'product',
            content_ids: _order.skus,
            value: _order.revenue,
            currency: _order.currency,
            order_id: _order.order_id
        };

        if (!data.is_dev) fbq('track', 'Purchase', fb_obj);

        if (mL_config.DEBUG) console.log(key + ' - ' + msg, { fb_obj: fb_obj });
    });


    mL.fbq = mL.fbq || {};

    mL.fbq.init = function() {
        if (mL.fbq.is_init || !mL.add_tracker || !window.fbq) return false;

        fbq('init', '710006952449865');

        if (!mL.is_checkout && !mL.is_app) fbq('track', 'PageView');

        mL.add_tracker('https://connect.facebook.net/en_US/fbevents.js', 'facebook');

        mL.fbq.is_init = true;

        if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
    };

}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));